module.exports = __webpack_public_path__ + "static/img/logo.e6b45b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 9